var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-content markdown-body" }, [
    _c("div", {
      directives: [{ name: "highlight", rawName: "v-highlight" }],
      ref: "markdownContent",
      domProps: { innerHTML: _vm._s(_vm.renderedMarkdown) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }